import React from "react";
import {
  AntDesign,
  Entypo,
  EvilIcons,
  Feather,
  FontAwesome,
  FontAwesome5,
  Fontisto,
  Foundation,
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
  Octicons,
  SimpleLineIcons,
  Zocial,
} from "@expo/vector-icons";
import { STYLES } from "../assets/styles";

function CustomIcon({ type, name, style = {}, onPress }) {
  style = { fontSize: STYLES.fontSizes.xlarge, padding: 5, ...style };
  let props = { type, name, style };
  if (onPress !== undefined) {
    props["onPress"] = onPress;
  }
  switch (type) {
    case "AntDesign": {
      return <AntDesign {...props} />;
    }
    case "Entypo": {
      return <Entypo {...props} />;
    }
    case "EvilIcons": {
      return <EvilIcons {...props} />;
    }
    case "Feather": {
      return <Feather {...props} />;
    }
    case "FontAwesome5": {
      return <FontAwesome5 {...props} />;
    }
    case "Fontisto": {
      return <Fontisto {...props} />;
    }
    case "Foundation": {
      return <Foundation {...props} />;
    }
    case "Ionicons": {
      return <Ionicons {...props} />;
    }
    case "MaterialCommunityIcons": {
      return <MaterialCommunityIcons {...props} />;
    }
    case "MaterialIcons": {
      return <MaterialIcons {...props} />;
    }
    case "Octicons": {
      return <Octicons {...props} />;
    }
    case "SimpleLineIcons": {
      return <SimpleLineIcons {...props} />;
    }
    case "Zocial": {
      return <Zocial {...props} />;
    }
    case "FontAwesome":
      return <FontAwesome {...props} />;
    default: {
      return null;
    }
  }
}

export default CustomIcon;
